import { Container, Row } from "reactstrap";
import LoginWithSweetalertContainer from "../../Componant/Authentication/LoginWithSweetalert";

const LoginWithSweetalert = () => {
  return (
    <Container fluid>
      <Row>
        <LoginWithSweetalertContainer />
      </Row>
    </Container>
  );
};

export default LoginWithSweetalert;
